module.exports = __webpack_public_path__ + "img/9-filters-03.6f0a76a6.svg";